<template>
    <layout-gestao>
        <notifications
            :moduleId="moduleCode"
            :componentId="pageID"
        >
        </notifications>
    </layout-gestao>
</template>

<script>
    import layout from './../../layouts/Main.vue'
    import ModuleMixin from './../../shared/mixins/ModuleMixin';

    export default {
        mixins: [
            ModuleMixin,
        ],
        components: {
            layoutGestao: layout,
            Notifications: () => import(/* webpackChunkName: "notification-list" */ '@/app/shared/components/manage/notification/ManageNotificationList'),
        },
        data() {
            return {
                pageID: 'notifications',
            }
        },
    }
</script>